import { RodRoomCaddyStatusStatsSummary } from '@bechtel/types';

export interface RodRoomStatsProps {
  rodRoomCaddyStat: RodRoomCaddyStatusStatsSummary;
}

export interface CaddyStatCardProps {
  value: number;
  valueColor: string;
  label: string;
}

